/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_ToInputs */

const en_tl_to = /** @type {(inputs: Tl_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to`)
};

const de_tl_to = /** @type {(inputs: Tl_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bis`)
};

/**
* | output |
* | --- |
* | "to" |
*
* @param {Tl_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_to = /** @type {((inputs?: Tl_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_ToInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_to(inputs)
	return en_tl_to(inputs)
});